<template>
  <div class="section-six-container">
    <ul class="product-list">
      <li
        class="product"
        v-for="(mask, index) of maskList"
        :key="index"
        @click="handleClickMask(mask, index)"
      >
        <div class="product-left">
          <img :src="mask.image" :alt="mask.title">
        </div>
        <div class="product-right">
          <div class="title">{{mask.title}}</div>
          <div class="description">{{mask.description}}</div>
        </div>
      </li>
    </ul>

    <div class="warmtip">点击进入详情</div>
  </div>
</template>

<script>
import anime from 'animejs';
import imgMask1 from '@/assets/six/mask_1.png';
import imgMask2 from '@/assets/six/mask_2.png';
import imgMask3 from '@/assets/six/mask_3.png';
import imgMask4 from '@/assets/six/mask_4.png';

export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      maskList: [
        {
          image: imgMask1,
          title: '文化巡礼预约',
          description:  '线上预约文化巡礼',
          link: 'http://hyqd.andthink.net/appx/H5/park/order/authorization.html?ParkInfoID=A1266CCF8CDA4FCB2C644B7AC4F99E06',
        },
        {
          image: imgMask3,
          title: 'VR网上展厅',
          description:  '720全景线上巡礼展馆',
          link: 'https://720yun.com/t/d9vksqdwp2b',
        },
        {
          image: imgMask4,
          title: 'AR街区阅读',
          description:  '街区文化新体验',
          link: 'https://h5ar.webar.arhieason.com/?webar_app_id=cf89dc2376a04a2989a6388bc560fbe4',
        },
        {
          image: imgMask2,
          title: '智慧地图导览',
          description:  '手绘地图+语音导览',
          link: 'https://www.schtwz.cn/ScenicWx/#/navigation?accessCode=001FF9906DE05DEA10B19432719BCE77',
        },
      ]
    }
  },
  mounted() {
    this.$emit("mounted");
  },
  watch: {
    isActive(newVal) {
      if (!newVal) return;
      this.enterAnimation();
    }
  },
  methods: {
    handleClickMask(mask) {
      location.href = mask.link;
    },
    enterAnimation() {
      anime({
        targets: '.section-six-container .product-left',
        translateX: [-300, 0],
        delay: anime.stagger(100, {start: 200}),
      });

      anime({
        targets: '.section-six-container .product-right',
        translateX: [300, 0],
        delay: anime.stagger(100, {start: 200}),
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.section-six-container {
  position: relative;
  width: 100%;
  height: 100%;
  background: url(~@/assets/six/bg.png) center center / 100% 100% no-repeat;
  overflow: hidden;
}

.product-list {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0;
  margin: 0;

  .product {
    display: flex;
    list-style: none;
    cursor: pointer;
    + .product {
      margin-top: 18px;
    }
  }
  .product-left {
    width: 37px;
    height: 83px;
    font-size: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .product-right {
    margin-left: 23px;
    .title {
      width: 148px;
      height: 45px;
      padding: 13px 10px 0;
      background: url(~@/assets/six/text_box.png) center center / 100% 100% no-repeat;
      color: #ffffff;
      font-size: 16px;
      box-sizing: border-box;
      text-align: center;
      font-weight: bold;
    }
    .description {
      padding: 0 10px;
      margin-top: 6px;
      color: #282828;
      font-size: 13px;
    }
  }
}

.warmtip {
  position: absolute;
  bottom: 10%;
  left: 50%;
  transform: translate(-50%, 0);
  color: #999999;
  font-size: 12px;
}
</style>